import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
import parserFilters from '@/utils/parserFilters'
import parserSlug from '@/utils/parserSlug'

Vue.use(Vuex)

const state = {
  purchaseOrders: [],
  amount: 0,
  amount_order: 0,
  receptions: [],
  receptionsDetails: [],
  sendreceptionsDetails: [],
  quantity: [],
  quantitys: [],
  addReception: [],
  addSendreception: [],
  purchaseOrder: {
    details: [],
    attachments: []
  },
  payments: [],
  paginationPayments: {
    currentPage: 1,
    perPage: 5,
    totalPurchaseOrders: 0,
    totalPages: 0
  },
  paginationsReceptionsDetails: {
    currentPage: 1,
    perPage: 5,
    totalPurchaseOrders: 0,
    totalPages: 0
  },
  paginationsReceptions: {
    currentPage: 1,
    perPage: 5,
    totalPurchaseOrders: 0,
    totalPages: 0
  },
  paginationsSendreceptionsDetails: {
    currentPage: 1,
    perPage: 5,
    totalPurchaseOrders: 0,
    totalPages: 0
  },
  paginationssupplierShipmentsDetails: {
    currentPage: 1,
    perPage: 5,
    totalPurchaseOrders: 0,
    totalPages: 0
  },
  paginationsSendreceptions: {
    currentPage: 1,
    perPage: 5,
    totalPurchaseOrders: 0,
    totalPages: 0
  },
  pagination: {
    currentPage: 1,
    perPage: 5,
    totalPurchaseOrders: 0,
    totalPages: 0
  },
  purchaseOrdersCatalog: {
    suppliers: [],
    customers: [],
    quotations: [],
    currencies: [],
    addresses: [],
    users: [],
    products: []
  },
  users: [],
  supplierShipments: [],
  supplierShipmentsDetails: [],
  filterParams: '',
  isModalVisible: false,
  isModalPropVisible: false,
  isModalAttachmentspoVisible: false,
  isModalAddPaymentOCVisible: false,
  isModalReceptionsVisible: false,
  isModalSendrecepVisible: false,
  trackings: []
}

const mutations = {
  PAYMENTS_SHOW (state, payload) {
    state.payments = payload.data
    state.paginationPayments = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      total: payload.total,
      totalPages: payload.last_page
    }
  },
  GET_AMOUNT (state, payload) {
    state.amount = payload.amount
    state.amount_order = payload.amount_order.total
  },
  INIT_PURCHASE_ORDER_DETAIL (state, payload) {
    state.purchaseOrder = payload
  },
  SET_MODAL_ADD_PAYMENT_OC_VISIBLE (state, payload) {
    state.isModalAddPaymentOCVisible = payload
  },
  GET_QUANTITY (state, payload) {
    state.quantity = payload
  },
  GET_QUANTITYS (state, payload) {
    state.quantitys = payload
  },
  SET_SUPPLIER_SHIPMENTS (state, payload) {
    state.supplierShipments = payload
  },
  SET_PURCHASE_ORDERS (state, payload) {
    state.purchaseOrders = payload.data
    state.pagination = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      totalPurchaseOrders: payload.total,
      totalPages: payload.last_page
    }
  },
  RECEPTIONS_SHOW (state, payload) {
    state.receptions = payload.data
    state.paginationsReceptions = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      total: payload.total,
      totalPages: payload.last_page
    }
  },
  RECEPTIONS_DETAILS_SHOW (state, payload) {
    state.receptionsDetails = payload.data
    state.paginationsReceptionsDetails = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      total: payload.total,
      totalPages: payload.last_page
    }
  },
  SUPPLIER_SHIPMENTS_DETAILS (state, payload) {
    state.supplierShipmentsDetails = payload
  },
  SENDRECEPTIONS_DETAILS_SHOW (state, payload) {
    state.sendreceptionsDetails = payload.data
    state.paginationsSendreceptionsDetails = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      total: payload.total,
      totalPages: payload.last_page
    }
  },
  ADD_PURCHASE_ORDER (state, payload) {
    state.purchaseOrders.unshift(payload)
  },
  ADD_PAYMENT_OC (state, payload) {
    state.payments.unshift(payload)
  },
  SUPPLIER_SHIPMENTS (state, payload) {
    state.supplierShipments.unshift(payload)
  },
  ADD_SUPPLIER_SHIPMENTS (state, payload) {
    state.supplierShipmentsDetails.supplierShipmentDetail.unshift(payload)
  },
  UPDATE_PURCHASE_ORDER (state, payload) {
    state.purchaseOrder = payload
  },
  UPDATE_PURCHASE_ORDERS_ACTION (state, payload) {
    const idx = state.purchaseOrders.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.set(state.purchaseOrders, idx, payload)
    }
  },
  DELETE_PURCHASE_ORDER (state, payload) {
    const idx = state.purchaseOrders.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.purchaseOrders, idx)
    }
  },
  DELETE_SUPPLIER_SHIPMENTS (state, payload) {
    const idx = state.supplierShipments.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.supplierShipments, idx)
    }
  },
  DELETE_SUPPLIER_SHIPMENTSD (state, payload) {
    const idx = state.supplierShipmentsDetails.supplierShipmentDetail.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.supplierShipmentsDetails.supplierShipmentDetail, idx)
    }
  },
  DELETE_RECEPTIONS (state, payload) {
    const idx = state.receptionsDetails.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.receptionsDetails, idx)
    }
  },
  DELETE_PURCHASE_ORDERS (state, payload) {
    for (let id of payload.ids) {
      const idx = state.purchaseOrders.findIndex(u => u.id === id)

      if (idx >= 0) {
        Vue.delete(state.purchaseOrders, idx)
      }
    }
  },
  DELETE_PAYMENTS_OC (state, payload) {
    const idx = state.payments.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.payments, idx)
    }
  },
  ADD_PURCHASE_ORDER_DETAIL (state, payload) {
    state.purchaseOrder.details.unshift(payload)
  },
  UPDATE_PURCHASE_ORDER_DETAIL (state, { payload, idx }) {
    if (idx >= 0) {
      Vue.set(state.purchaseOrder.details, idx, payload)
    }
  },
  UPDATE_PAYMENT_OC (state, { payload, idx }) {
    if (idx >= 0) {
      Vue.set(state.payments, idx, payload)
    }
  },
  DELETE_PURCHASE_ORDER_DETAIL (state, idx) {
    if (idx >= 0) {
      Vue.delete(state.purchaseOrder.details, idx)
    }
  },
  DELETE_PURCHASE_ORDER_DETAILS (state, payload) {
    for (let idx of payload.indexes) {
      if (idx >= 0) {
        Vue.delete(state.purchaseOrder.details, idx)
      }
    }
  },
  ADD_ATTACHMENT (state, payload) {
    state.purchaseOrder.attachments.unshift(payload)
  },
  SET_PURCHASE_ORDER (state, payload) {
    state.purchaseOrder = payload.data
  },
  SET_MODAL_VISIBLE (state, payload) {
    state.isModalVisible = payload
  },
  SET_MODAL_PROP_VISIBLE (state, payload) {
    state.isModalPropVisible = payload
  },
  SET_MODAL_ATTACHMENTS (state, payload) {
    state.isModalAttachmentspoVisible = payload
  },
  SET_FILTER_PARAMS (state, payload) {
    state.filterParams = payload
  },
  SET_CATALOG (state, { object, payload }) {
    state.purchaseOrdersCatalog[object] = payload.data
  },
  SET_MODAL_RECEPTIONS_VISIBLE (state, payload) {
    state.isModalReceptionsVisible = payload
  },
  SET_MODAL_SENDRECEP_VISIBLE (state, payload) {
    state.isModalSendrecepVisible = payload
  },
  SET_RECEPTIONS (state, payload) {
    state.receptionsDetails.unshift(payload)
  },
  SET_SENDRECEPTIONS (state, payload) {
    state.sendreceptionsDetails.unshift(payload)
  },
  SET_TRACKINGS (state, payload) {
    state.trackings = payload
  },
  ADD_TRACKING (state, payload) {
    state.trackings.unshift(payload)
  },
  SET_USERS (state, payload) {
    state.users = payload
  }
}

const actions = {
  async loadReceptionsDetails ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`receptions-details?page=${payload.page}&param=${payload.id},purchase_details_id`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'purcharse_orders_details.receptions', text: checkErrors.message }, { root: true })
      } else {
        commit('RECEPTIONS_DETAILS_SHOW', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadSupplierShipmentsDetails ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`suppliershipments-details/${payload.id}`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'purcharse_orders_details.receptions', text: checkErrors.message }, { root: true })
      } else {
        commit('SUPPLIER_SHIPMENTS_DETAILS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadSendReceptionsDetails ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`sendreceptions-details?page=${payload.page}&param=${payload.id},purchase_details_id`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'purcharse_orders_details.receptions', text: checkErrors.message }, { root: true })
      } else {
        commit('SENDRECEPTIONS_DETAILS_SHOW', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  initPurchaseOrder ({ commit }, payload) {
    commit('INIT_PURCHASE_ORDER_DETAIL', payload)
  },
  async loadQuantity ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`/receptions/quantity/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.purchase_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('GET_QUANTITY', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadSQuantity ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`/sendreceptions/quantity/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.invoiced', text: checkErrors.message }, { root: true })
      } else {
        commit('GET_QUANTITYS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadPurchaseOrders ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`purchase-orders?page=${payload.page}${state.filterParams}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.purchase_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_PURCHASE_ORDERS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadPayments ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`payment?page=${payload.page}&param=${payload.purshase_order_id},purchase_order_id`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.purchase_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('PAYMENTS_SHOW', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadAmount ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`payment/amount/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.purchase_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('GET_AMOUNT', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async addPurchaseOrder ({ commit }, payload) {
    const purchaseOrder = {
      delivery_time: payload.delivery_time,
      subtotal: parseFloat(payload.details.reduce((prev, cur) => prev + parseFloat(cur.total), 0).toFixed(2)),
      tax: parseFloat(payload.tax),
      total: parseFloat(payload.details.reduce((prev, cur) => prev + parseFloat(cur.total), 0).toFixed(2)) + parseFloat(payload.fletes) + parseFloat(payload.tax),
      fletes: parseFloat(payload.fletes),
      exchange_rate: parseFloat(payload.exchange_rate),
      customer_id: payload.customer_id,
      supplier_id: payload.supplier_id,
      billing_address_id: payload.billing_address_id,
      shipping_address_id: payload.shipping_address_id,
      currency_id: payload.currency_id,
      quotation_id: payload.quotation_id,
      comments: payload.comments,
      details: payload.details,
      status: payload.status,
      delivery_unit: payload.delivery_unit,
      payment_date_limit: payload.payment_date_limit,
      is_stock: payload.is_stock
    }

    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })

    try {
      const response = await axios.post('purchase-orders', purchaseOrder)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.purchase_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_PURCHASE_ORDER', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.purchase_orders', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async addReceptions ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`receptions`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'purchase_orders_detail.receptions_ordered', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_RECEPTIONS', response.data.data)
        commit('GET_QUANTITY', response.data.quantitys)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'purchase_orders_detail.receptions_ordered', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async editReceptions ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`receptionsedit`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'purchase_orders_detail.receptions_ordered', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'purchase_orders_detail.receptions_ordered', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async addShipmentDetail ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`addShipmentDetail`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.supplier_shipping', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_SUPPLIER_SHIPMENTS', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.supplier_shipping', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async addSendreceptions ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`sendreceptions`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'sales.invoice', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_SENDRECEPTIONS', response.data.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async editPurchaseOrder ({ commit }, payload) {
    const purchaseOrder = {
      folio: payload.folio,
      delivery_time: payload.delivery_time,
      total: parseFloat(payload.details.reduce((prev, cur) => prev + parseFloat(cur.total), 0).toFixed(2)) + parseFloat(payload.fletes) + parseFloat(payload.tax),
      subtotal: parseFloat(payload.details.reduce((prev, cur) => prev + parseFloat(cur.total), 0).toFixed(2)),
      fletes: parseFloat(payload.fletes),
      tax: parseFloat(payload.tax),
      customer_id: payload.customer_id,
      supplier_id: payload.supplier_id,
      exchange_rate: parseFloat(payload.exchange_rate),
      billing_address_id: payload.billing_address_id,
      shipping_address_id: payload.shipping_address_id,
      currency_id: payload.currency_id,
      quotation_id: payload.quotation_id,
      comments: payload.comments,
      details: payload.details,
      status: payload.status,
      delivery_unit: payload.delivery_unit,
      payment_date_limit: payload.payment_date_limit,
      is_stock: payload.is_stock
    }

    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })

    try {
      const response = await axios.put(`purchase-orders/${payload.id}`, purchaseOrder)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.purchase_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_PURCHASE_ORDER', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.purchase_orders', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async addAttachment ({ commit }, payload) {
    let formData = new FormData()
    formData.append('attachment', payload.file)
    formData.append('purchase_order_id', payload.purchase_order_id)
    formData.append('description', payload.description)

    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })

    try {
      const response = await axios.post(`attachments`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_ATTACHMENT', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.attachments', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async download ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      window.open(`${Vue.axios.defaults.baseURL}/attachments/${payload.id}/download`)
    } catch (error) {
      app.$Progress.fail()
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async deleteReception ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.delete(`receptions/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'purchase_orders_detail.receptions', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_RECEPTIONS', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'purchase_orders_detail.receptions', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async deleteSupplierShipment ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.delete(`suppliershipment/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.supplier_shipping', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_SUPPLIER_SHIPMENTS', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.supplier_shipping', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async deleteSupplierShipmentDetail ({ commit }, payload) {
    console.log(payload)
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.delete(`suppliershipmentDetail/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.supplier_shipping', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_SUPPLIER_SHIPMENTSD', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.supplier_shipping', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async deletePurchaseOrder ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.delete(`purchase-orders/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.purchase_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_PURCHASE_ORDER', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.purchase_orders', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async deletePurchaseOrders ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.delete(`purchase-orders/delete`, { params: { ids: payload.ids } })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.purchase_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_PURCHASE_ORDERS', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.purchase_orders', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async deletePaymentsOC ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.delete(`payment/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_PAYMENTS_OC', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.payments', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async addPurchaseOrderDetail ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    const PurchaseOrderDetail = {
      quantity: parseFloat(payload.quantity),
      unit_price: parseFloat(payload.unit_price),
      unit_price_raw: parseFloat(payload.unit_price_raw),
      total: parseFloat(payload.quantity * payload.unit_price),
      product: payload.product,
      edit: payload.edit,
      product_id: payload.product.id
    }
    commit('ADD_PURCHASE_ORDER_DETAIL', PurchaseOrderDetail)
    commit('SET_MODAL_VISIBLE', false)
    app.$Progress.finish()
    commit('SET_LOADING', false, { root: true })
  },
  async editPurchaseOrderDetail ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    const PurchaseOrderDetail = {
      id: payload.detail.id,
      quantity: parseFloat(payload.detail.quantity),
      unit_price: parseFloat(payload.detail.unit_price),
      unit_price_raw: parseFloat(payload.detail.unit_price_raw),
      total: parseFloat(payload.detail.quantity * payload.detail.unit_price),
      product: payload.detail.product,
      edit: payload.detail.edit,
      product_id: payload.detail.product.id
    }
    commit('UPDATE_PURCHASE_ORDER_DETAIL', { payload: PurchaseOrderDetail, idx: payload.index })
    commit('SET_MODAL_VISIBLE', false)
    app.$Progress.finish()
    commit('SET_LOADING', false, { root: true })
  },
  async deletePurchaseOrderDetail ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    commit('DELETE_PURCHASE_ORDER_DETAIL', payload.index)
    app.$Progress.finish()
    commit('SET_LOADING', false, { root: true })
  },
  async deletePurchaseOrderDetails ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    commit('DELETE_PURCHASE_ORDER_DETAILS', payload)
    app.$Progress.finish()
    commit('SET_LOADING', false, { root: true })
  },
  async loadPurchaseOrder ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`purchase-orders/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.purchase_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_PURCHASE_ORDER', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async actionPurchaseOrder ({ commit }, payload) {
    let props = ''
    payload.props && (props = payload.props)
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.put(`purchase-orders/${payload.id}/${payload.action}${props}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.purchase_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_PURCHASE_ORDER', response.data)
        commit('UPDATE_PURCHASE_ORDERS_ACTION', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  printReport ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      window.open(axios.defaults.baseURL + '/purchase-orders/export?order_by=currency_id,asc' + state.filterParams)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  printReportRecord ({ commit }, payload) {
    let props = ''
    payload.props && (props = `attention=${payload.props}`)
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      window.open(`${axios.defaults.baseURL}/purchase-orders/${payload.id}/export?${props}&lang=${payload.lang}`)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_MODAL_PROP_VISIBLE', false)
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  applyFilter ({ commit }, payload) {
    const filter = parserFilters(payload)
    commit('SET_FILTER_PARAMS', filter)
  },
  clearFilter ({ commit }, payload) {
    const filter = ''
    commit('SET_FILTER_PARAMS', filter)
  },
  async loadCatalog ({ commit }, payload) {
    let url = parserSlug(payload.url)
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`${url}${payload.filter}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.purchase_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CATALOG', { object: payload.url, payload: response.data })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadUsers ({ commit }) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`users/all`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_USERS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async addPaymentOC ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post('payment', payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        if (response.data.type === 'create') {
          commit('ADD_PAYMENT_OC', response.data.data)
          commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.payments', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
        } else if (response.data.type === 'update') {
          commit('UPDATE_PAYMENT_OC', response.data.data)
        }
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async saveReceptionIndividual ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`save-receptions-individual`, { receptions: payload })
      const checkErrors = checkResponse(response)
      console.log(checkErrors)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'sales.sent', text: checkErrors.message }, { root: true })
      } else {
        commit('RECEPTIONS_SHOW', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'purchase_orders_detail.receptions_ordered', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      console.log(e)
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadSupplierShipments ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`supplier-shipments/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'purcharse_orders_details.receptions', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_SUPPLIER_SHIPMENTS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async addSupplierShipment ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`suppliershipments-add`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        if (response.data.type === 'create') {
          commit('SUPPLIER_SHIPMENTS', response.data.data)
          commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.supplier-shipments', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
        }
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  loadCatalogAux ({ commit }, payload) {
    commit('SET_CATALOG', { object: payload.url, payload: payload })
  },
  setModalVisible ({ commit }, payload) {
    commit('SET_MODAL_VISIBLE', payload)
  },
  setModalPropVisible ({ commit }, payload) {
    commit('SET_MODAL_PROP_VISIBLE', payload)
  },
  setModalImportVisible ({ commit }, payload) {
    commit('SET_MODAL_IMPORT_VISIBLE', payload, { root: true })
  },
  setModalSendEmail ({ commit }, payload) {
    commit('SET_MODAL_SEND_EMAIL', payload, { root: true })
  },
  setModalCommentsVisible ({ commit }, payload) {
    commit('SET_MODAL_COMMENTS_VISIBLE', payload, { root: true })
  },
  setModalAttachmentspoVisible ({ commit }, payload) {
    commit('SET_MODAL_ATTACHMENTS', payload)
  },
  setModalAddPaymentOCVisible ({ commit }, payload) {
    commit('SET_MODAL_ADD_PAYMENT_OC_VISIBLE', payload)
  },
  setModalReceptionsVisible ({ commit }, payload) {
    commit('SET_MODAL_RECEPTIONS_VISIBLE', payload)
  },
  setModalSendRecepVisible ({ commit }, payload) {
    commit('SET_MODAL_SENDRECEP_VISIBLE', payload)
  },
  async loadTrackings ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`purchase-orders/${payload.id}/trackings`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_TRACKINGS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async addTracking ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`purchase-orders/${payload.id}/trackings`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.purchase_order_trackings', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
        commit('ADD_TRACKING', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  }
}

const getters = {
  purchaseOrder: state => state.purchaseOrder,
  purchaseOrders: state => state.purchaseOrders,
  purchaseOrdersCatalog: state => state.purchaseOrdersCatalog,
  pagination: state => state.pagination,
  receptions: state => state.receptions,
  quantity: state => state.quantity,
  quantitys: state => state.quantitys,
  receptionsDetails: state => state.receptionsDetails,
  sendreceptionsDetails: state => state.sendreceptionsDetails,
  paginationsReceptionsDetails: state => state.paginationsReceptionsDetails,
  paginationsSendreceptionsDetails: state => state.paginationsSendreceptionsDetails,
  paginationssupplierShipmentsDetails: state => state.paginationssupplierShipmentsDetails,
  paginationsReceptions: state => state.paginationsReceptions,
  isModalVisible: state => state.isModalVisible,
  isModalPropVisible: state => state.isModalPropVisible,
  isModalReceptionsVisible: state => state.isModalReceptionsVisible,
  isModalSendrecepVisible: (state, getters, rootState, rootGetters) => rootGetters['Sales/isModalSendrecepVisible'],
  isModalAttachmentspoVisible: state => state.isModalAttachmentspoVisible,
  isModalAddPaymentOCVisible: state => state.isModalAddPaymentOCVisible,
  filterParams: state => state.filterParams,
  payments: state => state.payments,
  paginationPayments: state => state.paginationPayments,
  amount: state => state.amount,
  amount_order: state => state.amount_order,
  addReception: state => state.addReception,
  supplierShipments: state => state.supplierShipments,
  supplierShipmentsDetails: state => state.supplierShipmentsDetails,
  trackings: state => state.trackings,
  users: state => state.users
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
